module.exports = __webpack_public_path__ + "img/gnosis.ecb6c65d.svg";